import { render, staticRenderFns } from "./PlatformLogo.vue?vue&type=template&id=37921067&"
import script from "./PlatformLogo.vue?vue&type=script&lang=js&"
export * from "./PlatformLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports